import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5c2a2bdf"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "block",
  id: "features"
};
const _hoisted_2 = {
  class: "content"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("Features");

const _hoisted_4 = {
  class: "row"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Innovative Value Retention Mechanism ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" The base value mechanism protects the NFT value from market volatility by preserving a portion of the mint price and increasing the base value after each transaction. ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Continued Growth of Value by Reinvesting ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" The base value pool automatically increases upon each subsequent sale in the secondary market and re-invests as per DeFi protocol to generate additional yields. ");

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Opportunities to Win Significant Prizes ");

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" The lottery service offers exciting rewards to all NFT holders. Each holder owns a stake to participate in the monthly lottery draw funded by the rewards pool. ");

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Guaranteed Flexible NFT Redemption ");

const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Holders can choose to redeem their NFTs at any time. Upon redemption, the smart contract will burn the NFT and return the base value along with rewards that are earned. ");

const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Amassing Resources to Develop Better Communities ");

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" The Alliance NFT program aims to empower the community by offering complimentary Level III Status in the Bincentive loyalty program and a premium feature - quasi staking, giving holders extra bonuses. ");

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "empty-item"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_landing_title = _resolveComponent("landing-title");

  const _component_feature_badge_card = _resolveComponent("feature-badge-card");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_landing_title, null, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_feature_badge_card, {
    badgeUrl: $data.featureBadge1
  }, {
    title: _withCtx(() => [_hoisted_5]),
    desc: _withCtx(() => [_hoisted_6]),
    _: 1
  }, 8, ["badgeUrl"]), _createVNode(_component_feature_badge_card, {
    badgeUrl: $data.featureBadge2
  }, {
    title: _withCtx(() => [_hoisted_7]),
    desc: _withCtx(() => [_hoisted_8]),
    _: 1
  }, 8, ["badgeUrl"]), _createVNode(_component_feature_badge_card, {
    badgeUrl: $data.featureBadge3
  }, {
    title: _withCtx(() => [_hoisted_9]),
    desc: _withCtx(() => [_hoisted_10]),
    _: 1
  }, 8, ["badgeUrl"]), _createVNode(_component_feature_badge_card, {
    badgeUrl: $data.featureBadge4
  }, {
    title: _withCtx(() => [_hoisted_11]),
    desc: _withCtx(() => [_hoisted_12]),
    _: 1
  }, 8, ["badgeUrl"]), _createVNode(_component_feature_badge_card, {
    badgeUrl: $data.featureBadge5
  }, {
    title: _withCtx(() => [_hoisted_13]),
    desc: _withCtx(() => [_hoisted_14]),
    _: 1
  }, 8, ["badgeUrl"]), _hoisted_15])])]);
}